import React from 'react';
import TablePlaceholder from '@app/component/placeholder/TablePlaceholder';


export const EmptyTablePlaceholder = React.memo(() => {
	return <>
		<div className="bg-white shadow-sm border-t border-gray-200">
			<div className="mx-auto max-w-7xl py-3 px-4 sm:px-6 lg:px-8 h-12" />
			<div className="bg-gray-50 shadow-sm border-t border-gray-100 h-12" />
		</div>
		<div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8">
			<div className="lg:flex lg:h-full lg:flex-col">
				<header className="flex items-center justify-end border-b border-gray-200 pb-4 lg:flex-none">
					<div className="flex h-6 w-px items-center flex-wrap gap-y-2 gap-x-2">
					</div>
				</header>
			</div>
			<TablePlaceholder />
		</div>
	</>;
});